module.exports = __webpack_public_path__ + "img/all_exam.ab1ae0b0.png";